// 画面処理遷移type
export type TsType = 'contact' | 'estimation' | undefined;

// 画面処理遷移type設定値
export const TS_SCREEN = {
    CONTACT: 'contact' as TsType,
    EST: 'estimation' as TsType,
};

// 画面名称
export const SCREEN_NAME = {
    SEARCH_TOP: 'search',
    SEARCH_RESULT: 'searchResult',
    ESTIMATION: 'estimation',
    CONTACT: 'contact',
    CUSTOMER_INFORMATION: 'customerInformation',
    CONFIRMATION: 'confirmation',
    COMPLETE: 'complete',
    EDIT_DEVICE_LIST: 'editDeviceList',
    EDIT_ESTIMATION: 'editEstimate',
};

// 検索結果の1画面あたり表示数
export const MAX_SEARCH_RESULT_SHOW_COUNT = 30;

// 機器リスト保持最大値
export const MAX_DEVICE_COUNT = 10;

// 都道府県初期値
export const DEFAULT_PREFECTURE_ID = '13';
// 市区群初期値
export const DEFAULT_CITY_ID = '632';

// タブ数値
export const TAB_ITEM_INDEX_0 = 0;
export const TAB_ITEM_INDEX_1 = 1;
export const TAB_ITEM_INDEX_2 = 2;

// タブ情報リスト
export const TAB_ITEM_LIST = [
    // 対応機種検索
    {
        tabIndex: TAB_ITEM_INDEX_0,
        tableName: '対応機種検索',
        navigation: '/',
        pathnameList: ['/', '/searchResult'],
    },
    // 見積り機器編集
    {
        tabIndex: TAB_ITEM_INDEX_1,
        tableName: '見積り機器編集',
        navigation: '/editDeviceList',
        pathnameList: ['/editDeviceList'],
    },
    // 見積り条件編集
    {
        tabIndex: TAB_ITEM_INDEX_2,
        tableName: '見積り条件編集',
        navigation: '/editEstimate',
        pathnameList: ['/editEstimate'],
    },
];

// 一時保存タイプ
export const TEMP_TYPE = {
    DEVICE_TEMP: '1', // 見積り機器編集
    ESTIMETE_TEMP: '2', // 見積り条件編集
};

// 一時保存のURLパス情報
export const TEMP_SAVE_PATH_LIST = [
    {
        type: TEMP_TYPE.DEVICE_TEMP, // 見積り機器編集
        path: 'tempRestore/device/',
        tabIndex: TAB_ITEM_INDEX_1,
    },
    {
        type: TEMP_TYPE.ESTIMETE_TEMP, // 見積り条件編集
        path: 'tempRestore/estimate/',
        tabIndex: TAB_ITEM_INDEX_2,
    },
];
